export default function PHP_array_walk_recursive() {
  return (
    <div>
      <h1>PHP_array_walk_recursive</h1>
    </div>
  );
}
